module.exports = __webpack_public_path__ + "static/media/phone_black1.371c85a8.png";